// @flow

import React, { Component } from 'react';
import { List } from 'immutable';
import {
  Modal,
  Dimmer,
  Segment,
  Loader,
  Message,
  Icon,
} from 'semantic-ui-react';
import * as Api from './api';
import ResourcesHeader from './components/ResourcesHeader';
import ResourcesPage from './components/ResourcesPage';

type Props = {
  open: boolean,
  resourceType: ResourceCategory,
  onResourceSelected: (resource: BucketResource) => void,
  onClose: () => void,
};

type State = {
  currentPage: number,
  currentFolder?: number,
  currentFilter: string,
  isFetchingFolders: boolean,
  isFetchingResources: boolean,
  isError: boolean,
  folders: List<BucketFolder>,
  resources: List<BucketResource>,
  hasNextPage: boolean,
  hasPreviousPage: boolean,
};

class ResourceSelector extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      currentPage: 1,
      currentFilter: '',
      isFetchingFolders: false,
      isFetchingResources: false,
      isError: false,
      folders: List(),
      resources: List(),
      hasNextPage: false,
      hasPreviousPage: false,
    };
  }

  onModalMount = () => {
    const { isFetchingFolders, isFetchingResources } = this.state;

    if (isFetchingFolders || isFetchingResources) {
      return;
    }

    this.setState({
      isFetchingFolders: true,
    });

    // Loading folders and first resources page
    Api.fetchFolders().then(folders => {
      this.setState(
        {
          isFetchingFolders: false,
          folders: List(folders),
        },
        this.fetchResources
      );
    });
  };

  fetchResources() {
    const {
      isFetchingResources,
      currentPage,
      currentFolder,
      currentFilter,
    } = this.state;
    const { resourceType } = this.props;

    if (isFetchingResources) return;

    this.setState({
      isFetchingResources: true,
    });

    Api.fetchResources(
      currentPage,
      resourceType,
      currentFolder,
      currentFilter
    ).then(
      ({ total, limit, resources }) =>
        this.setState({
          isFetchingResources: false,
          resources: List(resources),
          hasPreviousPage: currentPage > 1,
          hasNextPage: limit < total,
        }),
      error =>
        this.setState({
          isFetchingResources: false,
          isError: true,
        })
    );
  }

  onPreviousPage = () => {
    this.setState(
      {
        currentPage: this.state.currentPage - 1,
      },
      this.fetchResources
    );
  };

  onNextPage = () => {
    this.setState(
      {
        currentPage: this.state.currentPage + 1,
      },
      this.fetchResources
    );
  };

  onFolderChange = (folder: number) => {
    this.setState(
      {
        currentFolder: folder,
      },
      this.fetchResources
    );
  };

  onFilterChange = (value: string) => {
    this.setState(
      {
        currentFilter: value,
      },
      this.fetchResources
    );
  };

  renderContent() {
    const {
      isFetchingFolders,
      isFetchingResources,
      isError,
      folders,
      resources,
      hasPreviousPage,
      hasNextPage,
      currentFolder,
      currentFilter,
    } = this.state;
    const { onResourceSelected } = this.props;

    if (isFetchingFolders || isFetchingResources) {
      return (
        <Segment style={{ minHeight: '640px' }}>
          <Dimmer active>
            <Loader content="Chargement des ressources..." />
          </Dimmer>
        </Segment>
      );
    }

    if (isError) {
      return (
        <Message error icon>
          <Icon name="frown" />
          Une erreur est survenue. Impossible de charger les ressources graphiques.
        </Message>
      );
    }

    return (
      <div>
        <ResourcesHeader
          folders={folders}
          hasPreviousPage={hasPreviousPage}
          hasNextPage={hasNextPage}
          onPreviousPage={this.onPreviousPage}
          onNextPage={this.onNextPage}
          currentFolder={currentFolder}
          onFolderChange={this.onFolderChange}
          currentFilter={currentFilter}
          onFilterChange={this.onFilterChange}
        />
        <ResourcesPage resources={resources} onSelect={onResourceSelected} />
      </div>
    );
  }

  render() {
    const { open, onClose } = this.props;

    return (
      <Modal
        open={open}
        closeIcon
        size="fullscreen"
        onMount={this.onModalMount}
        onClose={onClose}
      >
        <Modal.Header>Sélectionnez une ressource graphique</Modal.Header>
        <Modal.Content>
          {this.renderContent()}
        </Modal.Content>
      </Modal>
    );
  }
}

export default ResourceSelector;



// WEBPACK FOOTER //
// ./src/shared/components/ResourceSelector/index.js